export const environment = {
  production: false,
  apiUrl: 'https://api-dev.cartco.in/api',
  wsUrl: 'https://api-dev.cartco.in',
  firebase: {
    apiKey: 'AIzaSyD01ixDar2zh0nWdfT0ssqyVqHRZBWyuJo',
    authDomain: 'cartco-13ef6.firebaseapp.com',
    projectId: 'cartco-13ef6',
    storageBucket: 'cartco-13ef6.firebasestorage.app',
    messagingSenderId: '799455117249',
    appId: '1:799455117249:web:7e66e56014e579e2453940',
    measurementId: 'G-QTYRX8RBG7',
  },
  fcmVapidKey: 'BMxO9voQQiWBACHK8I66QnCZNIpR936NB5f9s_0tcepFBaXVxDzzERDN5SpdhS111D2OxX9K9HHJ_NnHPQ-w6Fg',
  mapbox: {
    accessToken:
      'pk.eyJ1Ijoic3Jpa2FudGhnb3Zpbm9sbGEiLCJhIjoiY21qYzNkamR2MDgyODNlcWE0YnFxbnhkciJ9.qWdetoScNU78lUyiRozbMA',
  },
};


